import { render, staticRenderFns } from "./AbcCurve.vue?vue&type=template&id=671055b2&"
import script from "./AbcCurve.vue?vue&type=script&lang=js&"
export * from "./AbcCurve.vue?vue&type=script&lang=js&"
import style0 from "./AbcCurve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports